import React from "react";

const Loader = () => <h2>Loading... </h2>;

export default Loader;
